import global from './global';

export default () => {
    const apiRoot = global('apiRootGet') || '';
    const isLastBitLocale = apiRoot.split('/').pop().length === 2;

    return isLastBitLocale ? apiRoot.slice(0, apiRoot.length - 3) : apiRoot;
};
